export default "__VITE_ASSET__f27e0393__"